import { observer } from 'mobx-react';

function FormSkeleton() {
  return (
    <>
      <div className="animate-pulse">
        {/* Navigation skeleton */}
        <div className="h-16 w-full bg-gray-300 rounded mb-4"></div>

        <div className="mx-auto max-w-clientPortalMaxWidth px-2.5 pb-4 pt-16 md:flex-row lg:px-12">
          <div>
            {/* Heading skeleton */}
            <div className="mb-6">
              <div className="h-9 w-80 bg-gray-300 rounded"></div>
            </div>

            <div className="lg:flex lg:justify-between">
              <div className="w-full grow lg:w-[58%]">
                {/* Instructions text skeleton */}
                <div className="mb-4">
                  <div className="h-4 w-96 bg-gray-300 rounded mb-2"></div>
                  <div className="h-4 w-80 bg-gray-300 rounded"></div>
                </div>

                <div className="mt-4">
                  {/* First row: Collection Name and Internal Name fields */}
                  <div className="flex w-full flex-col lg:flex-row mb-6">
                    <div className="w-full lg:w-3/5">
                      {/* Collection Name field skeleton */}
                      <div className="mb-2 h-4 w-24 bg-gray-300 rounded"></div>
                      <div className="h-10 w-full bg-gray-300 rounded"></div>
                    </div>
                    <div className="ml-0 w-full lg:ml-6 lg:w-2/5 mt-4 lg:mt-0">
                      {/* Internal Name field skeleton */}
                      <div className="mb-2 h-4 w-28 bg-gray-300 rounded"></div>
                      <div className="h-10 w-full bg-gray-300 rounded"></div>
                    </div>
                  </div>

                  {/* Second row: Description and Image Upload */}
                  <div className="flex w-full flex-col lg:flex-row">
                    <div className="w-full lg:w-3/5">
                      {/* Description field skeleton */}
                      <div className="mb-2 h-4 w-20 bg-gray-300 rounded"></div>
                      <div className="h-24 w-full bg-gray-300 rounded"></div>
                    </div>
                    <div className="ml-0 w-full lg:ml-6 lg:w-2/5 mt-4 lg:mt-0">
                      {/* Image upload section skeleton */}
                      <div className="mb-2 h-4 w-16 bg-gray-300 rounded"></div>
                      <div className="h-32 w-full bg-gray-300 rounded border-2 border-dashed border-gray-400"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(FormSkeleton);
